const isRegisterPage = window.location.pathname === '/account/register';
const customRF = window.location.pathname === '/pages/wholesale-signup-form';
if(isRegisterPage || customRF) {
  let counter = 0;
  let selector = "#bss-b2b-register-form";
  const interval = setInterval(() => {
      if (document.querySelector(selector)) {
        handleRestyleRF();
        clearInterval(interval);
      } else {
          counter += 100;
          if (counter >= 10000) {
              clearInterval(interval);
          }
      }
  }, 100);
}

function handleRestyleRF(){
  // document.querySelectorAll(".bss-b2b-rf-field:has(input:not([type='file']))").forEach(item => {
  //   const input = item.querySelector("input")
  //   const label = item.querySelector("label");
  //   input.insertAdjacentElement("afterend", label);
  //   input.placeholder = label.innerText;
  // })
  document.querySelector(".bss-b2b-rf-submit-button .btn").classList.add("button")
document.querySelector(".bss-b2b-rf-submit-button .btn").classList.remove("btn")
}